// todo: refactor css only needed for marketing gallery
// import '../css/products.scss';
import '../css/marketing-gallery.scss';
import {GetAllMarketingBrochures} from '@services/ResourcesService/query.graphql';

if ( process.env.MOCK_API == 1 ) {
    require( '@services/ResourcesService/mocks' )
}

import PhotoGallery from '@modules/ui/PhotoGallery';

/* initilialize PhototGallery Modal */
(function () {

    $( function () {
        $( '#body-content' ).on( 'click', 'a[data-collection-id]', function ( e ) {
            e.preventDefault();
            openPhotoGallery( e.currentTarget );
        } );
    } );

    function openPhotoGallery ( target ) {
        //exit if a source url is not defined
        var collectionId = target.getAttribute( 'data-collection-id' );

        if ( !collectionId ) {
            return;
        }

        var $dialog = $(
            '<div id="upi-dialog" class="dark"><span class="close">Close</span><div class="upi-photo-gallery"><div class="upi-photo-preview"></div></div></div>' );
        $dialog.prependTo( 'body' ).hide();

        // collection title
        var caption = $( target ).parents( 'li' ).find( '.details' ).html();

        var gallery = new PhotoGallery( '#upi-dialog .upi-photo-gallery:first', {
            control_placement: 'bottom',
            template: 'galleryImageViewerMarketingMaterials',
            previewer_controls: true,
            slide_controller: {
                attributes: ['title', 'sku', 'image'],
                remote_query: {
                    query: GetAllMarketingBrochures,
                    variables: {id: collectionId}
                },
                slide_increment: 8
            }
        } );

        gallery.ready( function () {
            $dialog.show();
            // set collections title
            this.el.append( $( '#marketingRequestInstructions' ).clone() );
            this.previewer.after( '<div id="collection-title" class="upi-gallery-title">' + caption + '</div>' );
            this.bind( 'change:slide', this.proxy( resize_viewer ) );

            // resize photo-gallery to fit window
            var resize_id = null;
            $( window ).resize( this.proxy( function () {
                if ( resize_id ) {
                    clearTimeout( resize_id );
                    resize_id = null;
                }

                var self = this;
                resize_id = setTimeout( function () {
                    resize_viewer.call( self );
                }, 400 );
            } ) );

            function resize_viewer () {
                this.previewer.animate( {
                    height: $( window ).height() - (this.thumb_control.el.height() + 150) //  leaves space for slider
                } );
            }
        } );

        gallery.bind( 'error', function ( e, data ) {
            gallery.previewer.parent()
                .empty()
                .html(
                    '<div class="error">There was an error while attempting to load the content for this collection. Please try again later.</div>' );
        } );

        $dialog.on( 'click', '.close', function ( e ) { $dialog.trigger( 'close' ); } );
        $dialog.on( 'close', destroy_dialog );

        function destroy_dialog () {
            $dialog.fadeOut( function () {
                // unbind events bound to photo-gallery
                if ( typeof gallery != 'undefined' ) {
                    gallery.el.off();
                    gallery.slider_control.el.off();
                }

                $dialog.off();
                $dialog.remove();
            } );
        }
    }

})();
